import Image from 'next/image'
import type { LinkProps } from 'next/link'
import Link from 'next/link'
import type { HTMLAttributes, ReactNode } from 'react'
import { createElement, forwardRef } from 'react'

type NextLinkProps = LinkProps & HTMLAttributes<HTMLAnchorElement> & { children: ReactNode }

export const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ children, ...props }, ref) => {
    return createElement(Link, { ...props, legacyBehavior: true, ref }, children)
  },
)

NextLink.displayName = 'NextLink'

export const NextImage = Image
